import serviceGraphs from '@/utils/templates/apmTemplates/service.graphs.config';
import endpointGraphs from '@/utils/templates/apmTemplates/endppoint.graphs.config';
import instanceGraphs from '@/utils/templates/apmTemplates/instance.graphs.config';
import databaseGraphs from '@/utils/templates/apmTemplates/database.graphs.config';
import traceGraphs from '@/utils/templates/apmTemplates/trace.graphs.config';
import i18n from '@/plugins/i18n';

const apmDashboard = {
  service: [
    serviceGraphs().lineCharts,
    serviceGraphs().slowTraces,
    serviceGraphs().areaCharts,
    serviceGraphs().forecastDisabledLineCharts,
  ],
  trace: [traceGraphs().areaCharts, traceGraphs().windowsAreaCharts],
  endpoint: [endpointGraphs.lineCharts, endpointGraphs.areaCharts],
  instance: [instanceGraphs().lineCharts],
  appdb: [
    databaseGraphs().lineCharts,
    databaseGraphs().areaCharts,
    databaseGraphs().slow,
  ],
  slow: [
    {
      width: 3,
      title: i18n.global.t('endpoint-by-error'),
      icon: 'error',
      height: '12.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'endpoint_sla',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      aggregation: '/',
      aggregationNum: '100',
      parentService: true,
      unit: i18n.global.t('key'),
      sortOrder: 'ASC',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('key'),
      },
    },
    {
      width: '4',
      title: i18n.global.t('instances-by-error'),
      icon: 'error',
      height: '17.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_instance_sla',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      parentService: true,
      unit: i18n.global.t('key'),
      aggregation: '/',
      aggregationNum: '100',
      sortOrder: 'ASC',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('key'),
      },
    },
    {
      width: '3',
      title: i18n.global.t('endpoints-by-response-time-ms'),
      icon: 'slow',
      height: '17.5em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      metricName: 'endpoint_avg',
      unit: 'ms',
      parentService: true,
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      width: '4',
      title: i18n.global.t('instances-by-response-time-ms'),
      icon: 'slow',
      height: '17.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_instance_resp_time',
      queryMetricType: 'sortMetrics',
      chartType: 'ChartSlow',
      parentService: true,
      unit: 'ms',
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
  ],
};
export default apmDashboard;
